import { useAnalytics } from '@/core/analytics'
import { makeViewModel } from '@/core/architecture'

import { State } from './template'

export type Action = {
  skipSignUp: () => void
}

export const useViewModel = makeViewModel<State, Action>(() => {
  const { analytics } = useAnalytics()

  return {
    state: {},
    actions: {
      skipSignUp: () => {
        analytics?.track('click_skipSignUp')
      },
    },
  }
})
